// Viewport branch for the AppShell (design-system spec §3.1): ≥769 px renders
// the 216 px sidebar, below it the module strip. Mirrors the 768 px collapse
// breakpoint the office stylesheets already use. jsdom (no matchMedia)
// resolves desktop, which is what the shell unit tests exercise.

import { useEffect, useState } from "react";

const QUERY = "(min-width: 769px)";

export function useDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(() =>
    typeof window.matchMedia === "function" ? window.matchMedia(QUERY).matches : true,
  );

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const media = window.matchMedia(QUERY);
    const onChange = (event: MediaQueryListEvent) => {
      setIsDesktop(event.matches);
    };
    media.addEventListener("change", onChange);
    return () => {
      media.removeEventListener("change", onChange);
    };
  }, []);

  return isDesktop;
}
